import React, { useState, useContext, useEffect, useRef } from 'react';
import {
  Grid,
  Button,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  Paper,
} from '@mui/material';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import BlurTable from '../../../assets/img/blurTable.jpg';

import { SocketContext } from '../../../context/SocketContext';
import toast from 'react-hot-toast';

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import '../../../assets/css/buttons.css';

function SellScreenListWG({ updateAmountShortcut, isTab, isRefill }) {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const loadingTable = Array.from({ length: 12 });

  const {
    updateTicketSelectedKioskWG,
    WGBingoID,
    userSiblings,
    userChildren,
    session,
    operator,
    hall,
    updateUserLogin,
    currentUser,
    ticketsCH,
    userInfo,
    parentInfo,
    ticketsWG,
    updateTicketsWG,
    currentTicketWG,
    updateCurrentTicketWG,
    updateTicketsOKWithNewSaldo,
    isWGEnabled,
    ticketsTempWG,
  } = useContext(AppContext);

  const WGBingoIDRef = useRef(WGBingoID);
  useEffect(() => {
    WGBingoIDRef.current = WGBingoID;
  }, [WGBingoID]);

  useEffect(() => {
    console.log('currentTicketWG', currentTicketWG);
  }, [currentTicketWG]);

  const { socket } = useContext(SocketContext);

  useEffect(() => {
    if (!isWGEnabled) {
      return;
    }
    if (!WGBingoIDRef.current || WGBingoIDRef.current === 0) {
      return;
    }
    socket.emit('ticketsWG', {
      operator: operator,
      bingoName: hall,
      userID: parentInfo ? parentInfo.id : userInfo.id,
      userInfo: parentInfo ? parentInfo : userInfo,
      session: session,
      action: 'ticketsWG',
      bingoID: WGBingoIDRef.current,
    });
  }, [WGBingoID]);

  useEffect(() => {
    if (!isWGEnabled) {
      return;
    }
    if (!ticketsWG || ticketsWG.length === 0) {
      return;
    }
    for (let i = 0; i < ticketsWG.length; i++) {
      if (
        currentTicketWG.wgID === ticketsWG[i].wgID &&
        ticketsWG[i].currentBalance &&
        !isRefill &&
        !ticketsWG[i].isInUse
      ) {
        updateCurrentTicketWG(ticketsWG[i]);
        updateTicketSelectedKioskWG(ticketsWG[i]);
        updateAmountShortcut(ticketsWG[i].currentBalance);
      }
      if (
        currentTicketWG.wgID === ticketsWG[i].wgID &&
        ticketsWG[i].isCashedOut
      ) {
        updateCurrentTicketWG(false);
        updateTicketSelectedKioskWG(false);
        updateAmountShortcut(0);
      }
    }
  }, [ticketsWG]);

  useEffect(() => {
    const handleTicketsWG = (data) => {
      if (data.error) {
        toast.error(t('error.error'));
        return;
      }

      setLoading(false);
      updateTicketsWG(data.ticketsWG);
    };

    socket.on('ticketsWG', handleTicketsWG);

    return () => {
      socket.off('ticketsWG', handleTicketsWG);
    };
  }, [socket]);

  const sessionRef = useRef(session);
  useEffect(() => {
    sessionRef.current = session;
  }, [session]);

  const activateTicket = (ticket) => {
    updateCurrentTicketWG(ticket);
    updateTicketSelectedKioskWG(ticket);
    if (!isRefill) {
      setTimeout(() => {
        updateAmountShortcut(ticket.currentBalance);
      }, 450);
    }
  };

  // === UI only (glass) ===
  const glassBg = 'rgba(255,255,255,0.06)';
  const glassBorder = '1px solid rgba(255,255,255,0.12)';
  const headBg = 'rgba(0,0,0,0.20)';

  const tableContainerSx = {
    flex: 1,
    minHeight: 0,
    height: '100%',
    maxHeight: '100%',
    overflowY: 'auto',
    borderRadius: '18px',
    border: glassBorder,
    background: glassBg,
    boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.04)',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': { display: 'none' },

    '&.MuiPaper-root': { background: 'transparent', boxShadow: 'none' },
    '& .MuiTable-root': { background: 'transparent' },
    '& .MuiTableCell-root': {
      color: 'white',
      borderBottom: '1px solid rgba(255,255,255,0.08)',
      padding: '14px 16px',
      fontSize: '18px',
    },
    '& .MuiTableCell-head': {
      position: 'sticky',
      top: 0,
      zIndex: 2,
      background: headBg,
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      color: 'rgba(255,255,255,0.82)',
      fontWeight: 900,
      textTransform: 'uppercase',
      letterSpacing: '0.12em',
      fontSize: '15px',
      borderBottom: '1px solid rgba(255,255,255,0.10)',
    },
  };

  const actionBtnSx = {
    height: '44px',
    fontSize: '15px',
    borderRadius: '999px',
    border: '1px solid rgba(255,255,255,0.16)',
    color: 'white',
    fontWeight: 900,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    background: 'rgba(255,255,255,0.06)',
    '&:hover': { background: 'rgba(255,255,255,0.10)' },
  };

  const actionBtnSelectedSx = {
    ...actionBtnSx,
    border: '1px solid rgba(34,197,94,0.35)',
    background: 'rgba(34,197,94,0.10)',
    '&:hover': { background: 'rgba(34,197,94,0.14)' },
  };

  const rowSx = (isSelected, index) => ({
    '&:last-child td, &:last-child th': { border: 0 },
    backgroundColor: isSelected
      ? 'rgba(34,197,94,0.14)'
      : index % 2 === 0
        ? 'rgba(255,255,255,0.03)'
        : 'rgba(255,255,255,0.015)',
    '&:hover td': {
      backgroundColor: isSelected
        ? 'rgba(34,197,94,0.18)'
        : 'rgba(255,255,255,0.05)',
    },
  });

  return (
    <Grid
      item
      xs={12}
      sx={{
        padding: '10px',
        height: '100%',
        minHeight: isTab ? 0 : '555px',
        width: '100%',
        marginTop: '0',
        marginLeft: 0,
        display: 'flex',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        minHeight: 0,
      }}
    >
      {!isTab && (
        <h2 style={{ textAlign: 'left', width: '100%', margin: '0 0 10px 0' }}>
          {t('sales.payoutTicket')}
        </h2>
      )}

      <Grid
        container
        flexDirection="row"
        sx={{
          flex: 1,
          minHeight: 0,
          width: '100%',
          marginTop: 0,
          marginLeft: 0,
          display: 'flex',
          justifyContent: 'flex-start',
          alignContent: 'stretch',
          alignItems: 'stretch',
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            width: '100%',
            maxWidth: '100% !important',
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {loading ? (
            <TableContainer component={Paper} sx={tableContainerSx}>
              <Table
                sx={{ color: 'white', background: 'transparent' }}
                stickyHeader
                aria-label="simple table"
              >
                <TableHead sx={{ background: 'transparent' }}>
                  <TableRow>
                    <TableCell align="center">
                      {t('apneBilleter.ticketID')}
                    </TableCell>
                    <TableCell align="center">{t('sales.saldo')}</TableCell>
                    <TableCell align="center">{t('sales.status')}</TableCell>
                    <TableCell align="center"> </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {loadingTable.map((index) => (
                    <TableRow sx={rowSx(false, index)} key={index}>
                      <TableCell component="th" scope="row" align="center">
                        <Skeleton />
                      </TableCell>
                      <TableCell align="center">
                        <Skeleton />
                      </TableCell>
                      <TableCell align="center">
                        <Skeleton />
                      </TableCell>
                      <TableCell align="center">
                        <Skeleton />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <TableContainer component={Paper} sx={tableContainerSx}>
              <Table
                sx={{ color: 'white', background: 'transparent' }}
                stickyHeader
                aria-label="simple table"
              >
                <TableHead sx={{ background: 'transparent' }}>
                  <TableRow>
                    <TableCell align="center">
                      {t('apneBilleter.ticketID')}
                    </TableCell>
                    <TableCell align="center">{t('sales.saldo')}</TableCell>
                    <TableCell align="center">{t('sales.status')}</TableCell>
                    <TableCell align="center"> </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {ticketsWG && ticketsWG.length > 0 && (
                    <>
                      {ticketsWG.map((ticket, index) =>
                        ticket.wgInfo.isCashedOut ||
                        ticket.isCashedOut ||
                        ticketsTempWG.some(
                          (ticketTemp) =>
                            parseInt(ticketTemp.id) === ticket.wgID
                        ) ? null : (
                          <TableRow
                            key={index}
                            sx={rowSx(
                              currentTicketWG?.wgID === ticket.wgID,
                              index
                            )}
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              align="center"
                              sx={{
                                color:
                                  currentTicketWG?.wgID === ticket.wgID
                                    ? '#18ff18'
                                    : 'inherit',
                              }}
                            >
                              {ticket.wgID}
                            </TableCell>

                            <TableCell
                              align="center"
                              sx={{
                                color:
                                  currentTicketWG?.wgID === ticket.wgID
                                    ? '#18ff18'
                                    : 'inherit',
                              }}
                            >
                              {ticket.wgInfo.isInUse || ticket.isInUse
                                ? '-'
                                : ticket.currentBalance !== undefined &&
                                    ticket.currentBalance !== null
                                  ? ticket.currentBalance
                                  : '-'}
                            </TableCell>

                            <TableCell
                              align="center"
                              sx={{
                                color:
                                  currentTicketWG?.wgID === ticket.wgID
                                    ? '#18ff18'
                                    : 'inherit',
                              }}
                            >
                              {ticket.wgInfo.isInUse || ticket.isInUse
                                ? t('sales.inGame')
                                : ticket.wgInfo.isCashedOut ||
                                    ticket.isCashedOut
                                  ? t('sales.closed')
                                  : t('sales.open')}
                            </TableCell>

                            <TableCell align="center">
                              {ticket.isInUse && !isRefill ? (
                                <></>
                              ) : (
                                <>
                                  {currentTicketWG?.wgID !== ticket.wgID ? (
                                    <>
                                      {!isRefill && (
                                        <Button
                                          size="small"
                                          variant="outlined"
                                          sx={actionBtnSx}
                                          onClick={() => {
                                            activateTicket(ticket);
                                          }}
                                        >
                                          {!isRefill
                                            ? t('sales.payout')
                                            : t('sales.refill')}
                                        </Button>
                                      )}

                                      {isRefill && (
                                        <Button
                                          size="small"
                                          variant="outlined"
                                          sx={actionBtnSx}
                                          onClick={() => {
                                            activateTicket(ticket);
                                          }}
                                        >
                                          {!isRefill
                                            ? t('sales.payout')
                                            : t('sales.refill')}
                                        </Button>
                                      )}
                                    </>
                                  ) : (
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      sx={actionBtnSelectedSx}
                                      onClick={() => {
                                        activateTicket(ticket);
                                      }}
                                    >
                                      {t('sales.selected')}
                                    </Button>
                                  )}
                                </>
                              )}
                            </TableCell>
                          </TableRow>
                        )
                      )}
                    </>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default SellScreenListWG;
